import { render, staticRenderFns } from "./CommunicationManagement.vue?vue&type=template&id=5d2dfecc&"
import script from "./CommunicationManagement.vue?vue&type=script&lang=js&"
export * from "./CommunicationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports